import { getTermCondition, updateTermCondition, getSubPangkalanTermCondition, updateSubPangkalanTermCondition, getTermConditionById, getTermConditionHistory } from '../../utils/api';
import { FAILED, LOADING, SUCCESS, userTypeMap } from './constants';

export const fetchTermCondition = (tabParam) => {
  return async (dispatch) => {
    const key = 'TermCondition';
    dispatch(loadingAction(true, key));
    try {
      const response = await getTermCondition(userTypeMap[tabParam]);
      const data = response.data?.data || response.data;
      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const editTermCondition = (params) => {
  return async (dispatch) => {
    const key = 'UpdateTermCondition';
    dispatch(loadingAction(true, key));
    try {
      const body = {
        title: params.title,
        content: params.content,
        version: params.version,
        isEnabled: params.isEnabled,
        isRequired: params.isRequired
      };

      await updateTermCondition(body);
      dispatch(successAction(true, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const fetchSubPangkalanTermCondition = () => {
  return async (dispatch) => {
    const key = 'SubPangkalanTermCondition';
    dispatch(loadingAction(true, key));
    try {
      const response = await getSubPangkalanTermCondition();
      const data = response.data?.data || response.data;
      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const fetchTermConditionById = (historyId) => {
  return async (dispatch) => {
    const key = 'TermConditionById';
    dispatch(loadingAction(true, key));
    try {
      const response = await getTermConditionById(historyId);
      const data = response.data?.data || response.data;
      dispatch(successAction(data, key));
      return data;
    } catch (error) {
      dispatch(failedAction(error.message, key));
      throw error;
    }
  };
};

export const fetchTermConditionHistory = (params) => {
  return async (dispatch) => {
    const key = 'TermConditionHistory';
    dispatch(loadingAction(true, key));
    try {
      const response = await getTermConditionHistory(params);
      const responseData = response.data?.data || response.data;

      const historyData = {
        data: Array.isArray(responseData) ? responseData : [],
        meta: {
          page: params.page || 1,
          totalPage: response.data?.meta?.totalPage || 1,
          ...response.data?.meta
        },
        message: response.data?.message || ''
      };

      dispatch(successAction(historyData, key));
      return historyData;
    } catch (error) {
      dispatch(failedAction(error.message, key));
      throw error;
    }
  };
};

export const editSubPangkalanTermCondition = (agreementId, params, callback, errorCallback) => {
  return async (dispatch) => {
    const key = 'UpdateSubPangkalanTermCondition';
    dispatch(loadingAction(true, key));
    try {
      const body = {
        title: params.title,
        content: params.content,
        version: params.version,
        isEnabled: params.isEnabled,
        isRequired: params.isRequired
      };

      const response = await updateSubPangkalanTermCondition(agreementId, body);
      dispatch(successAction(response.data, key));
      if (callback) callback();
    } catch (error) {
      dispatch(failedAction(error.message, key));
      if (errorCallback) errorCallback(error);
    }
  };
};

export function failedAction(message, key) {
  return { type: FAILED, message, key };
}

export function loadingAction(isLoading, key) {
  return { type: LOADING, isLoading, key };
}

export function successAction(data, key) {
  return { type: SUCCESS, data, key };
}

